<template>
    <div>
        <!-- <buttonlist  @exps="exps"  @search="search" @reflash="reflash" ref="SetBtn"></buttonlist> -->
        <!-- <el-card class="box-card">
            <div style="display: flex;background: white">
                <div style="width: 50%;text-align: left;display: flex">
                    <el-button type="primary" size="mini"  @click="send">获取数据</el-button>
                </div>
            </div>
        </el-card> -->
        <!-- <div style="display: flex;background: white">
                <el-card class="box-card" style="width: 20%;">
                <div slot="header" class="clearfix">
                <span>卡片名称</span>
                </div>
                <div v-for="o in 4" :key="o" class="text item">
                {{'列表内容 ' + o }}
                </div>
                </el-card>
                <el-card class="box-card" style="width: 20%;">
                <div slot="header" class="clearfix">
                <span>卡片名称</span>
                </div>
                <div v-for="o in 4" :key="o" class="text item">
                {{'列表内容 ' + o }}
                </div>
                </el-card>
        </div>		 -->
        <!-- <el-card class="box-card">
        <div style="display: flex;background: white">
        <div style="width: 50%;text-align: left;display: flex">
        <el-button type="primary" size="mini"  @click="send" :disabled="!btn.btn1">查看计算历史</el-button>
        <el-button type="primary" size="mini"  @click="send" :disabled="!btn.btn2">审核汇报工时</el-button>
        <el-button type="primary" size="mini"  @click="send" :disabled="!btn.btn3">反审汇报工时</el-button>
        <el-button type="primary" size="mini"  @click="send" :disabled="!btn.btn4">标定本月成本</el-button>
        <el-button type="primary" size="mini"  @click="send" :disabled="!btn.btn5">反标定本月成本</el-button>
        <el-button type="primary" size="mini"  @click="send" :disabled="!btn.btn6">清除所有在制标定</el-button>
        </div>
        </div>
        </el-card>  -->
        <el-divider content-position="left">{{ $t('getapi[2088]') }}</el-divider>
        <table>
            <tr>
                <td style="width:60px;text-align: right">{{ $t('getapi[1974]') }}:</td>
                <td style="width:150px;">
                    <el-select filterable v-model="dataDetail.cboyear" size="mini" style="margin-righ:20px">
                        <el-option v-for="item in yearList" :key="item.value" :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select>
                </td>

            </tr>
            <tr>
                <td style="width:60px;text-align: right">{{ $t('getapi[1975]') }}:</td>
                <td style="width:150px;">
                    <el-select filterable v-model="dataDetail.cbomonth" size="mini" style="margin-righ:20px">
                        <el-option v-for="item in monthList" :key="item.value" :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select>
                </td>

            </tr>
        </table>
        <table>
            <tr>
                <td>
                    <el-checkbox v-model="IsNew" disabled='true'></el-checkbox>
                    <span style="font-size:larger">{{ $t('getapi[7647]') }}</span>
                </td>
                <td>
                    <el-button type="primary" size="mini" @click="execute()" :loading='loading'>{{ $t('getapi[7648]')
                        }}
                    </el-button>
                </td>
            </tr>
            <tr>
                <td>
                    <span style="color:blue;">{{ $t('getapi[7649]') }}</span>
                </td>

            </tr>
        </table>


    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: '3_outcostpanel',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight-240,
                    maxHeight: this.$windowSize.tableHeight-240,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight-180
            }
        },
        data() {
            return {
                IsNew: true,
                IsCaculate: '未计算',
                IsSure: '未标定',
                dataDetail: {
                    cboyear: '',
                    cbomonth: 1,
                },
                yearList: [],
                monthList: [
                    {
                        value: 1,
                        label: 1
                    },
                    {
                        value: 2,
                        label: 2
                    },
                    {
                        value: 3,
                        label: 3
                    },
                    {
                        value: 4,
                        label: 4
                    },
                    {
                        value: 5,
                        label: 5
                    },
                    {
                        value: 6,
                        label: 6
                    },
                    {
                        value: 7,
                        label: 7
                    },
                    {
                        value: 8,
                        label: 8
                    },
                    {
                        value: 9,
                        label: 9
                    },
                    {
                        value: 10,
                        label: 10
                    }, {
                        value: 11,
                        label: 11
                    },
                    {
                        value: 12,
                        label: 12
                    }
                ],
                viewurl: '/CostCalc/ActualCsotView/GetSumRunningHourView',
                expurl: '/CostCalc/ActualCsotView/GetSumRunningHourViewToExecl',
                dialogVisible: false, //时间选择弹框
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: 100, // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                isShowEdit: false, // 是否显示编辑页面
                tableHeader: [],
                PlanTypeArray: [], // 计划类型数组
                isEdit: true, // 是否新增操作
                selectIDList: [],
                selectObj: {
                    part_code: '',
                    part_version: '',
                    exclusively_id: 0,
                    shelflife: ''
                },
                copyparam: {
                    startMonth: '',
                    copyMonth: '',
                },
                btn: {
                    btn1: false,
                    btn2: false,
                    btn3: false,
                    btn4: false,
                    btn5: false,
                    btn6: false,
                    btnbegin: false,
                    btnstop: false,
                }
            };
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.PlanTypeArray = Array.methods.getPlanType();
            let thisyear = new Date().getFullYear();
            for (let i = 0; i < 10; i++) {
                let obj = {
                    value: thisyear - i,
                    label: thisyear - i
                };
                that.yearList.push(obj);
            }
            that.dataDetail.cboyear = thisyear;
            that.authority();


        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('SalLogicticscsvViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                let limits = 1;
                //that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);

                //that.$refs.SetBtn.SetButtonEnable('export',true);
                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                return;

                // //只读权
                // if (that.$limits.ReadOnlyRightsView('plv2', 375, 1, that.total)) {
                // 	if (that.total > 0) {
                // 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                // 	} else {
                // 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
                // 	}
                // }
                // //操作权限-查询级别
                // limits = that.$limits.OperationAuthorityView('plv2', 375, 1, that.total);
                // // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
                // switch (limits) {
                // 	case -1:
                // 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
                // 		break;
                // 	case 1:
                // 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                // 		break;
                // 	case -2:
                // 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
                // 		break;
                // 	case 2:
                // 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                // 		break;
                // 	case -3:
                // 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
                // 		break;
                // 	case 3:
                // 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                // 		break;
                // 	default:
                // 		break;
                // }
                // if(limits==-1||limits==1)that.closeAllRightButton();
                // else that.btnauthority();
            },
            btnauthority() {
                let that = this;
                that.btn.send = false;
                that.btn.delete = false;
                that.btn.print = false;

            },
            closeAllRightButton() {
                let that = this;
                that.btn.send = false;
                that.btn.delete = false;
                that.btn.print = false;
            },

            execute() {
                let that = this;
                let data = {
                    TYear: that.dataDetail.cboyear,
                    Month: that.dataDetail.cbomonth,
                    LangType: that.$processdata.getLang(),
                }
                that.loading = true;
                that.$http.urlpost('/CostCalc/CostJustView/IssueCostJustManage', data, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[4950]'));//'执行完成'
                    }
                    that.loading = false;
                });

            },
            showdialog() {
                let that = this;
                if (that.selectObj.exclusively_id == 0) {
                    that.$message.warning(that.$t('getapi[8623]'));//'请选择一项！'
                    return;
                }
                that.dialogVisible = true;
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDList = val;
                if (that.selectIDList.length > 0) {
                    that.btn.send = true;
                    that.btn.delete = true;
                    that.btn.print = true;
                } else {
                    that.btn.send = false;
                    that.btn.delete = false;
                    that.btn.print = false;
                }
            },

            handleSizeChange(val) {
                this.pageSize = val;
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.pageIndex = 1;
                that.$refs.ser.clearInput(that.isVisible, 'SumRunningHourInfo');
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let token = JSON.parse(that.userData).token;
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    Param: datac
                };
                that.$http.urlpost(that.viewurl, data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.authority();
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this;
                that.isShowEdit = true;
                that.isEdit = true;
                let parm = {
                    Code: row.PO_Code,
                    List: []
                };
                this.$refs.order.clearInput(this.isShowEdit, parm);
            },
            // 新增
            add() {
                let that = this;
                let datetime = Common.methods.getDatetime()
                that.isEdit = false;
                that.isShowEdit = true;
                that.dataDetail = {
                    Head: {},
                    Lists: []
                };
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            //按月拷贝成本
            copy() {
                let that = this;
                that.dialogVisible = true;

            },
            copyconfirm() {
                //
                let that = this;
                that.btn.copy = false
                let parm = {
                    "newmonth": that.copyparam.copyMonth.split("-")[1],
                    "newyear": that.copyparam.copyMonth.split("-")[0],
                    "oldmonth": that.copyparam.startMonth.split("-")[1],
                    "oldyear": that.copyparam.startMonth.split("-")[0],
                }

                that.$http.urlpost('/Inv/PartCost/InvPartStdCostCopyCost', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                    }
                    that.btn.copy = true;
                    that.dialogVisible = false;
                });


            },
            send() {
                let that = this;
                that.loading = true;
                that.$http.urlpost('/CostCalc/PurView/GetLatestPurPriceView', {}, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                    }
                    that.loading = false;
                });
            },
            print() {
                let that = this;
                let parm = {
                    po_no: '',
                    TemplateName: '08Invoice_CSV.xlsx'
                };

                for (let i = 0; i < that.selectIDList.length; i++) {
                    parm.po_no = parm.po_no + "'" + that.selectIDList[i].exclusively_id + "',";
                }
                parm.po_no = parm.po_no.substring(0, parm.po_no.length - 1);

                that.btn.print = false;
                that.loading = true;
                that.$http.urlpost('/Print/CSVPrint', parm, function (res) {
                    that.btn.print = true;
                    if (res.Success == 1) {
                        let hrefurl = res.Key;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
            },
            deleteline() {
                let that = this;
                let parm = {
                    Delivery_Note_N: that.selectIDList[0].Delivery_Note_N,
                };
                that.$http.urlpost('/Sal/Tru/DeleteCsv', parm, function (res) {
                    if (res.Success == 1) {
                        that.reflash();
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    }
                });

            },
            // 导出
            exps() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let token = JSON.parse(that.userData).token;
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    Param: datac
                };
                that.$http.urlpost(that.expurl, data, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
            },
            // 保存
            save() {
                let that = this;
                let parm = that.dataDetail;
                that.$http.urlpost('/Pur/Requisition/SaveData', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                    }
                });
            },
            //
            editInfo1() {
            },
            editInfo2() {
            },
            editInfo3() {
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    .bbl {
        margin: 0px auto 10px;
        white-space: pre;
        span {
            margin-left: 10px;
            min-width: 70px;
            text-align: left;
            line-height: 20px;
            display: inline-block;
            margin-right: 0px;
        }
    }
</style>
